module.exports = __webpack_public_path__ + "img/industry-img6.cf21824b.png";